module.exports = __webpack_public_path__ + "static/img/send-success.aa314c76.svg";